export default "__VITE_ASSET__B8vBNbp6__"